export enum UserType {
  APPLICANT = 'applicant',
  IM = 'im',
  COSS = 'coss',
  ADMIN = 'admin',
  RNEJO = 'rnejo',
  RU = 'ru',
  INTEGRATION_PLATFORM = 'integrationPlatformUser'
}
